export default "/assets/images/peacekeeper-3.ef86914e1ed8afb0.png";